import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./styles.module.css";

interface MediaFileUploadFormProps {
  dragActive: boolean;
  disableUploadButton: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
  handleDrag: (event: React.DragEvent | React.DragEnterEvent) => void;
  handleMediaFilesChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleDropWrapper: (event: React.DragEvent) => void;
  onButtonClick: () => void;
}

const MediaFileUploadForm: React.FC<MediaFileUploadFormProps> = ({
  dragActive,
  disableUploadButton,
  inputRef,
  handleDrag,
  handleMediaFilesChange,
  handleDropWrapper,
  onButtonClick,
}) => {
  const { t } = useTranslation();

  return (
    <form
      className={classes["form-file-upload"]}
      id="form-file-upload"
      onDragEnter={handleDrag}
      onSubmit={(e) => e.preventDefault()}
      data-testid="form-file-upload"
    >
        <input
          className={classes["input-file-upload"]}
          ref={inputRef}
          type="file"
          id="input-file-upload"
          onChange={handleMediaFilesChange}
          disabled={disableUploadButton}
          data-testid="input-file-upload"
        />
        <label
          id="label-file-upload"
          htmlFor="input-file-upload"
          aria-label={t("Upload_Media_Initial_Text1")}
          className={
            dragActive
              ? classes["label-file-upload-drag-active"]
              : classes["label-file-upload"]
          }
        >
          <div>
            <div
              className={`${classes.hideMobViewText} global-txt fw-light`}
            >
              {t("Upload_Media_Initial_Text1")}
            </div>
            <div
              className={`${classes.hideMobViewText} global-txt fw-light`}
            >
              {t("Upload_Media_Initial_Text2")}
            </div>
            <button
              className=" mt-2 "
              aria-label="addattachment"
              onClick={onButtonClick}
              data-testid="browse-button"
              style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', font: 'inherit' }}
            >
              <input
                type="button"
                name="mediaFiles"
                aria-label="addattachment"
                value="Add Attachment"
                className={disableUploadButton ? classes.disabled : ""}
                disabled={disableUploadButton}
              />
              <i className="fas fa-upload relative -left-8 text-white pointer-events-none"></i>
            </button>
          </div>
        </label>
        {dragActive && (
          <section
            className={classes["drag-file-element"]}
            id="drag-file-element"
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDropWrapper}
            aria-label="Drag and drop file upload zone"
            data-testid="drag-file-element"
          ></section>
        )}
      </form>
    );
};

export default MediaFileUploadForm;
